import { AppSession } from '@prisma/client'
import { message } from 'antd'
import { error } from 'winston'
import { Api } from '~/core/trpc'
type AppSessionStatus = 'ACTIVE' | 'TO_ONBOARD' | 'DISABLED'

type Options = {
  appSession: AppSession
}
export const useAppSession = ({ appSession }: Options) => {
  const appSessionUpdate = Api.appSession.update.useMutation()
  const retellAgentUpdateMutation = Api.retell.updateRetellAgent.useMutation()

  const setStatus = async (status: AppSessionStatus) => {
    if (appSessionUpdate.isLoading) {
      return
    }

    try {
      await appSessionUpdate.mutateAsync({
        where: { id: appSession.id },
        data: { status: status as any },
      })

      if (appSession.role === 'Receptionist') {
        retellAgentUpdateMutation
          .mutateAsync({
            appSessionId: appSession.id,
          })
          .catch(error =>
            console.error(
              `Could not update retell agent for appSession: ${appSession.id}`,
              error.message,
            ),
          )
      }

      window.location.reload()
    } catch (error) {
      console.error('Unknown Error', error)
      message.error('Something went wrong')
    }
  }

  return {
    setStatus,
    isLoading: appSessionUpdate.isLoading,
  }
}
